<template>
    <div class="wrapper">
        <TitleModules title="产品案例" english="INTRODUCE" type="blue"></TitleModules>
        <div class="img-text-content-box">
            <div class="img-content-box" style="margin-right: 160px;">
                <img class="content-img7" data-src="../../static/img/content-img7.png" alt="">
                <img class="content-img6" data-src="../../static/img/content-img6.png" alt="">
            </div>
            <div class="text-content-box">
                <img class="number-bg" data-src="../../static/img/bg-img1.png" alt="">
                <div class="text-content-title">基于走路运动步数的<br>线上虚拟运动社交电商步步挣</div>
                <div class="text-content-subtitle">SPORTS SOCIAL E-COMMERCE EARNS MONEY STEP BY STEP</div>
                <div class="text-content"><span>累计运营1000万用户</span>。<br><br> 使命：让走路步数产生价值<br>愿景：希望看到更多用户因我们而使的生活更健康！ <br><br>【步步挣】积极相应国务院关于印发全民健身计划（2021-2025年）的通知；鼓励上千万用户参与全民健身健步走，开发标准统一的科学运动积分体系：动力币，向每日运动达标的用户发放激励政策，以及兑换商品消费券等福利 <br><br>【步步挣】积极相应国务院关于印发全民健身计划（2021-2025年）的通知：平台每日在线开展全民健身健步走：3000步、4000步、5000步、6000步等虚拟运动；截止2021年8月1日每天服务20万用户。</div>
            </div>
        </div>
    </div>
</template>
<script>
import TitleModules from '../components/Title-modules'
export default {
    name: 'virtual',
    components: {
        TitleModules
    },
    data(){
        return {

        }
    },
    created(){
        localStorage.setItem('path','./virtual')
        localStorage.setItem('index',2)
    },
    mounted(){
        this.handleScroll()
    },
    methods: {
        handleScroll(){
            const images = document.querySelectorAll("img");
            // 传给IntersectionObserver的回调函数
            // 在目标元素能看见时触发一次，目标元素看不见了时再触发一次
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const image = entry.target;
                        const data_src = image.getAttribute("data-src");
                        image.setAttribute("src", data_src);
                        console.log('触发')
                        // 图片被加载后取消观察
                        observer.unobserve(image);
                    }
                });
            });
            images.forEach(image => {
                observer.observe(image);
            });
        }
    }
}
</script>
<style scoped>
@media only screen and (max-width: 1480px){
    .content-img7{
        height: 441px;
        display: block;
    }
    .content-img6{
        height: 416px;
        display: block;
        margin-top: 70px;
    }
    .img-text-content-box{
        width: 100%;
        height: 1100px;
        display: flex;
        justify-content: center;
        align-items:center;
    }
    .text-content-box{
        width: 568px;
        position: relative;
    }
    .text-content-title{
        font-size: 37px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 51px;
    }
    .text-content-subtitle{
        font-size: 24px;
        margin-top: 15px;
    }
    .text-content{
        width: 546px;
        font-size: 21px;
        line-height: 40px;
        margin-top: 40px;
    }
    .text-content > span{
        font-size: 24px;
        font-weight: bold;
        color: #4468E6;
    }
    .number-bg{
        position: absolute;
        height: 203px;
        left: 26px;
        top: -48px;
    }
}
@media only screen and (min-width: 1480px){
    .content-img7{
        height: 620px;
        display: block;
    }
    .content-img6{
        height: 585px;
        display: block;
        margin-top: 100px;
    }
    .img-text-content-box{
        width: 100%;
        height: 1600px;
        display: flex;
        justify-content: center;
        align-items:center;
    }
    .text-content-box{
        width: 810px;
        position: relative;
    }
    .text-content-title{
        font-size: 52px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 72px;
    }
    .text-content-subtitle{
        font-size: 34px;
        margin-top: 20px;
    }
    .text-content{
        width: 778px;
        font-size: 30px;
        line-height: 56px;
        margin-top: 50px;
    }
    .text-content > span{
        font-size: 34px;
        font-weight: bold;
        color: #4468E6;
    }
    .number-bg{
        position: absolute;
        height: 285px;
        left: 40px;
        top: -65px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/virtual.vue